export const setAuthTokenKey="@AuthContext/SET_AUTH_TOKEN";
export const setUnauthorisedUserKey="@AuthContext/SET_UNAUTHORISED";
export const setAuthUserObjectKey="@AuthContext/SET_AUTH_USER_DATA";
export const requestLoginAPICallKey="@AuthContext/REQUEST_LOGIN_API_CALL";
export const updateAuthUserInfoKey="@AuthContext/UPDATE_AUTH_USER_INFO";
export const updateAuthUserPrinterType="@AuthContext/UPDATE_AUTH_USER_PRINTER_TYPE";
